import { useFormikContext } from "formik";
import { isUndefined } from "../../../utils/helpers/typeHelper";
import { isNullOrEmpty } from "../../../utils/helpers/stringHelper";
import { useEffect } from "react";

const handleDefaultSelection = (setter, value, options, defaultSelectionIndex) => {
  if (isNullOrEmpty(value) && defaultSelectionIndex < options.length) {
    setter(options[defaultSelectionIndex].value);
  }
};

export const useDefaultSelection = (name, options, defaultSelectionIndex) => {
  const { setFieldValue, values } = useFormikContext();
  const value = values[name];

  useEffect(() => {
    if (!isUndefined(defaultSelectionIndex)) {
      const setter = (newValue) => setFieldValue(name, newValue);

      handleDefaultSelection(setter, value, options, defaultSelectionIndex);
    }
  }, [defaultSelectionIndex, name, options, setFieldValue, value])
};